import {
  AdminReports,
  CompletedSigAgents,
  ConferenceQualifiers,
  FactorMilestones,
  WheelOfLove,
  UserReports,
  PromoCodeRedemptions,
} from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    AdminReports,
    '/admin-reports',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin Reports',
    }
  ),
  RouteFactory.create(
    CompletedSigAgents,
    '/completed-sig-agents',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - Completed Signature Agents',
    }
  ),
  RouteFactory.create(
    ConferenceQualifiers,
    '/conference-qualifiers',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - Conference Qualifiers',
    }
  ),
  RouteFactory.create(
    FactorMilestones,
    '/factor-milestones',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - Award Milestones',
    }
  ),
  RouteFactory.create(
    WheelOfLove,
    '/wheel-of-love',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - Wheel of Love',
    }
  ),
  RouteFactory.create(
    UserReports,
    '/user-reports',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - User Report',
    }
  ),
  RouteFactory.create(
    PromoCodeRedemptions,
    '/promo-code-redemptions',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner']),
    ],
    {
      name: 'Admin - Promo Code Redemptions',
    }
  ),
]
